import fy2Api from '@/api/fy2Api';
import BaseModule from "@/common/BaseModule";
import { Module } from "vuex";
import { LOAD_CHANNELS_ROOT, SEO } from '../protocols';
import userApi from '@/api/userApi';

export interface State {
    lives: LiveRoom[],
    shortTags: ShortVideoTag[],
    shortVideos: ShortVideo[],
    channels: ChannelInfo[],
    left: {
        lives: LiveRoom[],
        tags: ShortVideoTag[],
        channels: ChannelInfo[],
    }
}

class ChannelsHome extends BaseModule<State> {
    constructor() {
        super(LOAD_CHANNELS_ROOT[0])
    }

    generate(): Module<State, any> {
        return {
            namespaced: true,
            state: {
                left: {
                    lives: [],
                    tags: [],
                    channels: [],
                },
                lives: [],
                shortTags: [],
                shortVideos: [],
                channels: [],
            },
            actions: {
                async loadLeft({ state }) {
                    if (state.left.lives.length == 0) {
                        let { live, shortVideo } = await fy2Api.getChannelMenu()
                        state.left.lives = live.list
                        state.left.tags = shortVideo.list

                        if (fy2Api.token) {
                            state.left.channels = await userApi.getMyChannels()
                        }
                    }
                },
                async loadHome({ state, dispatch }, route: Route) {
                    let { lives, shortVideo, channels } = await fy2Api.getChannelHome()
                    state.lives = lives
                    state.shortTags = shortVideo.tags
                    state.shortVideos = shortVideo.videos
                    state.channels = channels
                },
                [LOAD_CHANNELS_ROOT[1]]({ dispatch, commit }, route: Route) {
                    const seoTitle = '频道-福音影视网|福音TV'
                    commit('updateSeo', Object.assign({}, SEO, { title: seoTitle }), { root: true })
                    return Promise.all([
                        dispatch('loadLeft', route),
                        dispatch('loadHome', route)
                    ])
                }
            }
        }
    }
}

export default new ChannelsHome()